import React, { useState } from 'react'
import NumberFormat from 'react-number-format'

import { Button } from '@leasequery/lq.react-component-library'

import '../form/RitForm.css'

export default function FairValue({
	navigateForward,
	navigateBack,
	content,
	errorMessage,
	value,
}) {
	const [fairValue, setFairValue] = useState(value)
	const [formattedValue, setFormattedValue] = useState(value)

	const regexp = /^[0-9]*(\.[0-9]{0,2})?$/

	function handleChange(e) {
		let input = e.target.value
		setFormattedValue(input)
		input = parseFloat(input.replace(/,/g, ''))

		if (input === '' || regexp.test(input)) {
			setFairValue(input)
		}
	}

	return (
		<div>
			<div className='form'>
				<NumberFormat
					min='0'
					name='fair-value'
					value={formattedValue ? formattedValue : ''}
					onKeyDown={(e) =>
						(e.keyCode === 69 ||
							e.keyCode === 187 ||
							e.keyCode === 189 ||
							e.keyCode === 107 ||
							e.keyCode === 109) &&
						e.preventDefault()
					}
					onChange={(e) => {
						handleChange(e)
					}}
					thousandSeparator={true}
					isNumericString={true}
					required
				/>
				<label htmlFor='fair-value' className='label-name'>
					<span className='content-name'>{content}</span>
				</label>
			</div>
			<div className='errorMessage-Container'>{errorMessage}</div>
			<div>
				<Button
					buttonType='secondary'
					className='form-Button'
					onClick={() => navigateBack()}
				>
					Back
				</Button>
				<Button
					buttonType='primary'
					className='form-Button'
					onClick={() => navigateForward(fairValue)}
				>
					Next
				</Button>
			</div>
		</div>
	)
}
